import React from "react";

const KeyBoardIcon = ({ width, height, style }) => {
  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0006 3.05273H24.3709C25.2886 3.05273 26.1075 3.08101 26.8417 3.17984C30.7525 3.61752 31.8115 5.45292 31.8115 10.4792V19.4021C31.8115 24.4284 30.7525 26.2638 26.8417 26.7015C26.1075 26.8003 25.3028 26.8286 24.3709 26.8286H11.0006C10.0829 26.8286 9.26397 26.8003 8.5298 26.7015C4.61894 26.2638 3.56006 24.4284 3.56006 19.4021V10.4792C3.56006 5.45292 4.61894 3.61752 8.5298 3.17984C9.26397 3.08101 10.0829 3.05273 11.0006 3.05273Z"
        stroke="#40E5A0"
        strokeWidth="1.69424"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9238 11.9766H25.1195"
        stroke="#7E858F"
        strokeWidth="0.752994"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2661 20.1484H10.2943H25.133"
        stroke="#EFF1F5"
        strokeWidth="1.12949"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6333 31.2891H24.7519"
        stroke="#EFF1F5"
        strokeWidth="1.12949"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9086 11.9462H10.9213"
        stroke="#7E858F"
        strokeWidth="2.82373"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5673 11.9462H15.58"
        stroke="#7E858F"
        strokeWidth="2.82373"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default KeyBoardIcon;
